<template>
    <div class="mt-8 mb-4">
        <v-card-title>{{ $t('celebrations_report') }}</v-card-title>
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-col class="py-4 col-xs-12 col-sm-4 col-md-3 col-lg-2 col-xl-2 my-0 col-12">
                    <v-select
                            v-model="selectedMonth"
                            :items="monthItems"
                            :label="$t('month')"
                            item-text="text"
                            item-value="value"
                            hide-details
                            @change="fetchData"
                    ></v-select>
                </v-col>
                <v-btn
                        class="primary ml-2"
                        color="white"
                        :loading="loading"
                        :disabled="!items.length"
                        @click="exportCsv"
                >
                    <v-icon class="mr-1">mdi-file-export</v-icon>{{ $t('export_data') }}
                </v-btn>
            </v-card-title>
            <v-data-table
                    class="elevation-0"
                    :mobile-breakpoint="1400"
                    :headers="tableHeaders"
                    :items="items"
                    :loading="loading"
                    disable-sort
                    fixed-header
            >
                <template v-slot:item.eventType="{ item }">
                    {{ eventTypeLabel(item.eventType) }}
                </template>
                <template v-slot:item.eventDate="{ item }">
                    {{ formatEventDate(item.eventDate) }}
                </template>
                <template v-slot:item.yearsOfService="{ item }">
                    {{ item.yearsOfService != null ? item.yearsOfService : '-' }}
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
    import { apiCall } from "@/utils/api.js";
    import { mapActions } from "vuex";

    export default {
        name: "CelebrationsReport",
        data: (context) => ({
            selectedMonth: new Date().getMonth() + 1,
            items: [],
            loading: false,
            tableHeaders: [
                { text: context.$t('fullname'), value: "employeeName", align: 'center' },
                { text: context.$t('event_type'), value: "eventType", align: 'center' },
                { text: context.$t('event_date'), value: "eventDate", align: 'center' },
                { text: context.$t('years_of_service'), value: "yearsOfService", align: 'center' },
            ],
        }),
        computed: {
            monthItems() {
                return Array.from({ length: 12 }, (_, i) => ({
                    value: i + 1,
                    text: new Date(2000, i, 1).toLocaleString(this.$i18n.locale, { month: 'long' }),
                }));
            },
        },
        created() {
            this.fetchData();
        },
        methods: {
            ...mapActions("service", ["setSnackbar"]),
            monthRange() {
                const year = new Date().getFullYear();
                const month = this.selectedMonth;
                const pad = (n) => String(n).padStart(2, '0');
                const lastDay = new Date(year, month, 0).getDate();
                return {
                    startDate: `${year}-${pad(month)}-01`,
                    endDate: `${year}-${pad(month)}-${pad(lastDay)}`,
                };
            },
            eventTypeLabel(type) {
                return type === 'BIRTHDAY' ? this.$t('birthday') : this.$t('work_anniversary');
            },
            formatEventDate(iso) {
                if (!iso) return '';
                const [year, month, day] = iso.split('-').map(Number);
                return new Date(year, month - 1, day).toLocaleString(this.$i18n.locale, { month: 'short', day: 'numeric' });
            },
            fetchData() {
                this.loading = true;
                apiCall("post", "reports/celebrations", { data: this.monthRange() }, true)
                    .then((response) => {
                        if (response.data.status === true) {
                            this.items = response.data.result;
                        } else {
                            this.setSnackbar({ color: "error", text: this.$t('unknown_error'), toggle: true });
                        }
                    })
                    .catch(() => {
                        this.setSnackbar({ color: "error", text: this.$t('unknown_error'), toggle: true });
                    })
                    .finally(() => this.loading = false);
            },
            exportCsv() {
                this.loading = true;
                apiCall("post", "reports/exportcelebrations", { data: this.monthRange() }, true, "blob")
                    .then((response) => {
                        const url = window.URL.createObjectURL(response.data);
                        const monthName = new Date(2000, this.selectedMonth - 1, 1).toLocaleString(this.$i18n.locale, { month: 'long' });
                        const a = document.createElement("a");
                        a.style.display = "none";
                        a.href = url;
                        a.download = `${monthName}-celebrations.csv`;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(() => {
                        this.setSnackbar({ color: "error", text: this.$t('unknown_error'), toggle: true });
                    })
                    .finally(() => this.loading = false);
            },
        },
    };
</script>
